import {
    FormControl,
    FormGroup,
    FormArray,
    Validators
} from '@angular/forms';

export let projectForm: FormGroup = new FormGroup({
    logo: new FormControl(),
    name: new FormControl('', [
        Validators.required,
        Validators.maxLength(50)
        // custom function to name already exists
    ]),
    description: new FormControl('', [
        Validators.minLength(0),
        Validators.maxLength(250)
    ]),
    partners: new FormControl(),
    partner: new FormControl('', [
        Validators.required
    ]),
    country: new FormControl('', [
        Validators.required
    ]),
    admins: new FormControl(),
    admin: new FormGroup({
      first_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(30)
      ]),
      last_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(30)
      ]),
      email: new FormControl('', [
        Validators.required,
        //Validators.pattern('^[0-9A-Za-z_\.]+?@[0-9A-Za-z_\.]+?\.([A-Za-z]{2}|[A-Za-z]{3})$')
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')

      ])
    }),
    lpartner: new FormControl(),
    ladmin: new FormControl(),
    code: new FormControl()
});

export let formPartner = {
    logo: new FormControl(),
    name: new FormControl('', [
        Validators.required,
        Validators.pattern("^([a-zA-Z0-9-_]+[,.]?[ ]?|[a-z]+['-]?)+$"),
        Validators.minLength(3),
        Validators.maxLength(50)
        // custom function to name already exists
    ]),
    url: new FormControl(),
    email: new FormControl('', [
     // Validators.pattern('^[0-9A-Za-z_\.-]+?@[0-9A-Za-z_\.-]+?\.([A-Za-z]{2}|[A-Za-z]{3}|[A-Za-z\.]{2,6})$')
     Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
    ]),
    active: new FormControl()
};

export let formUser = {
    logo: new FormControl(),
    first_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    last_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    partner: new FormControl(), // for project/content admin
    date_of_birth: new FormControl(), // for student
    roll: new FormControl(), // for student
    gender: new FormControl('', Validators.pattern('^([fF]emale|[mM]ale|[oO]ther)$')),
    contact: new FormGroup({
        email: new FormControl('', [
            Validators.required,
            //Validators.pattern('^[0-9A-Za-z_\.]+?@[0-9A-Za-z_\.]+?\.([A-Za-z]{2}|[A-Za-z]{3})$')
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]),
        phone: new FormControl()
    }),
    address: new FormGroup({
        addr1: new FormControl(),
        addr2: new FormControl(),
        code: new FormControl()
    }),
    project_id: new FormControl(''), // internal
    school_id: new FormControl(''), // internal
    role: new FormControl(''), // internal
    username: new FormControl(''),
    password: new FormControl(''),
    grade: new FormControl(''), // for student
    class: new FormControl(), // for student
    key_subject: new FormControl(),// for teacher
    active: new FormControl()
};

export let formTeacher = {
    logo: new FormControl(),
    first_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
    ]),
    last_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
    ]),
    partner: new FormControl(),
    date_of_birth: new FormControl(),
    roll: new FormControl(),
    gender: new FormControl('', Validators.pattern('^([fF]emale|[mM]ale|[oO]ther)$')),
    contact: new FormGroup({
        email: new FormControl('', [
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]),
        phone: new FormControl()
    }),
    address: new FormGroup({
        addr1: new FormControl(),
        addr2: new FormControl(),
        code: new FormControl()
    }),
    project_id: new FormControl(''),
    school_id: new FormControl(''),
    role: new FormControl(''),
    username: new FormControl(''),
    password: new FormControl(''),
    grade: new FormControl(''),
    class: new FormControl(),
    key_subject: new FormControl('', [
        Validators.required
    ]),
    active: new FormControl()
};


export let formStudent = {
    logo: new FormControl(),
    first_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    last_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    date_of_birth: new FormControl(), // for student
    roll: new FormControl(), // for student
    gender: new FormControl('', Validators.required),
    grade: new FormControl('', Validators.nullValidator), // for student
    class: new FormControl('', Validators.nullValidator), // for student
    username: new FormControl(''),
    password: new FormControl(''),
    active: new FormControl()
};

export let formAdmin = {
    logo: new FormControl(),
    first_name: new FormControl('', [
        Validators.required,
        Validators.pattern("^([a-zA-Z0-9-_@./#&+]+[,.]?[ ]?|[a-z]+['-]?)+$"),
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    last_name: new FormControl('', [
        Validators.required,
        Validators.pattern("^([a-zA-Z0-9-_@./#&+]+[,.]?[ ]?|[a-z]+['-]?)+$"),
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    partner: new FormControl('',Validators.required ), // for project/content admin
    date_of_birth: new FormControl(), // for student
    roll: new FormControl(), // for student
    gender: new FormControl(),
    contact: new FormGroup({
        email: new FormControl('', [
            Validators.required,
//            Validators.pattern('^[0-9A-Za-z_\.]+?@[0-9A-Za-z_\.]+?\.([A-Za-z]{2}|[A-Za-z]{3})$')
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]),
        phone: new FormControl()
    }),
    address: new FormGroup({
        addr1: new FormControl(),
        addr2: new FormControl(),
        code: new FormControl()
    }),
    project_id: new FormControl(''), // internal
    school_id: new FormControl(''), // internal
    role: new FormControl('',Validators.required), // internal
    username: new FormControl(''),
    password: new FormControl(''),
    grade: new FormControl(''), // for student
    class: new FormControl(), // for student
    key_subject: new FormControl(),// for teacher
    active: new FormControl()
};

export let formGradeClass = {
    _id: new FormControl(),
    name: new FormControl(),
    year: new FormControl()
};
// end
